import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ContentHeader} from '@components';
import {PfButton, PfImage} from '@profabric/react-components';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import SettingsTab from './SettingsTab';

const StyledUserImage = styled(PfImage)`
  --pf-border: 3px solid #adb5bd;
  --pf-padding: 3px;
`;

const Profile = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [activeTab, setActiveTab] = useState('ACTIVITY');
  const [t] = useTranslation();
  const toggle = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <ContentHeader title="Profile" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <div className="card card-primary card-outline">
                <div className="card-body box-profile">
                  <div className="text-center">
                    <StyledUserImage
                      width={100}
                      height={100}
                      rounded
                      src={user?.imageUrl || '/img/default-profile.png'}
                      alt="User profile"
                    />
                  </div>
                  <h3 className="profile-username text-center">
                    {user?.data?.name}
                  </h3>
                  <p className="text-muted text-center">
                    {user?.data?.designation}
                  </p>
                  <ul className="list-group list-group-unbordered mb-3">
                    <li className="list-group-item">
                      <b>{t<string>('Last Signed In')}</b>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="card">
                <div className="card-header head p-0">
                  <ul className="nav nav-pills">
                    {/* <li className="nav-item"></li>
                    <li className="nav-item"></li> */}
                    <li className="nav-item">
                      {/* <button
                        type="button"
                        className={`nav-link ${
                          activeTab === 'SETTINGS' ? 'active' : ''
                        }`}
                        onClick={() => toggle('SETTINGS')}
                      >
                        {t<string>('main.label.settings')}
                      </button> */}
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  <div className="tab-content">
                    {/* <ActivityTab isActive={activeTab === 'ACTIVITY'} /> */}
                    {/* <TimelineTab isActive={activeTab === 'TIMELINE'} /> */}
                    <SettingsTab isActive={activeTab === 'SETTINGS'} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Profile;
